"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.Img = exports.imgMixin = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var Box_1 = require("../Box");
var Mode;
(function (Mode) {
    Mode[Mode["Pending"] = 0] = "Pending";
    Mode[Mode["Error"] = 1] = "Error";
    Mode[Mode["Loaded"] = 2] = "Loaded";
})(Mode || (Mode = {}));
exports.imgMixin = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  opacity: 0;\n  transition: opacity 250ms;\n"], ["\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  opacity: 0;\n  transition: opacity 250ms;\n"])));
var Placeholder = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  opacity: 1;\n"], ["\n  ", "\n  opacity: 1;\n"])), exports.imgMixin);
exports.Img = styled_components_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n\n  ", ";\n"], ["\n  ", "\n  ", "\n\n  ", ";\n"])), exports.imgMixin, Box_1.boxMixin, function (_a) {
    var mode = _a.mode;
    switch (mode) {
        case Mode.Pending:
            return "";
        case Mode.Loaded:
            return "\n          opacity: 1;\n        ";
        case Mode.Error:
            return "\n          opacity: 0;\n        ";
    }
});
exports.Image = react_1.default.forwardRef(function (_a, forwardedRef) {
    var srcs = _a.srcs, alt = _a.alt, onError = _a.onError, onLoad = _a.onLoad, onComplete = _a.onComplete, rest = __rest(_a, ["srcs", "alt", "onError", "onLoad", "onComplete"]);
    var _b = __read((0, react_1.useState)(Mode.Pending), 2), mode = _b[0], setMode = _b[1];
    var ref = react_1.default.useRef(null);
    var handleError = (0, react_1.useCallback)(function () {
        setMode(Mode.Error);
        onError && onError();
        onComplete && onComplete();
    }, [onComplete, onError]);
    var handleLoad = (0, react_1.useCallback)(function () {
        setMode(Mode.Loaded);
        onLoad && onLoad();
        onComplete && onComplete();
    }, [onComplete, onLoad]);
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.complete) {
            handleLoad();
        }
    }, [handleLoad, ref]);
    if (srcs.length === 0) {
        return react_1.default.createElement(Placeholder, __assign({}, rest));
    }
    var _c = __read(srcs), src1x = _c[0], remainingSrcs = _c.slice(1);
    return (react_1.default.createElement(exports.Img, __assign({ ref: (0, compose_react_refs_1.default)(ref, forwardedRef), mode: mode, src: src1x }, (remainingSrcs
        ? {
            srcSet: "".concat(src1x, " 1x, ").concat(remainingSrcs
                .map(function (src, i) { return "".concat(src, " ").concat(i + 2, "x"); })
                .join(", ")),
        }
        : {}), { onError: handleError, onLoad: handleLoad, alt: alt !== null && alt !== void 0 ? alt : "a meaningful description" }, rest)));
});
exports.Image.displayName = "Image";
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Image.js.map